import React, { useEffect } from "react";

import localStorage from "shared/util/localStorage";
import isRouteMatch from "shared/util/isRouteMatch";
import { ROUTES } from "routers/shared/util/consts";

const PARTIAL_SIGNUP_ACTION_RECORDED_KEY = "partial_signup_action_recorded";
const PARTIAL_SIGNUP_ROUTES = [
	...ROUTES.Onboarding,
];

const ActionPartialSignup = ({ location }) => {
	const hasShown = localStorage.getItem(PARTIAL_SIGNUP_ACTION_RECORDED_KEY);
	const shouldShow = !!(
		window.gtag &&
		!hasShown &&
		isRouteMatch(location, PARTIAL_SIGNUP_ROUTES)
	);

	useEffect(() => {
		if (!shouldShow) {
			return;
		}

		localStorage.setItem(PARTIAL_SIGNUP_ACTION_RECORDED_KEY, Date.now());
		window.gtag("event", "conversion", { "send_to": "AW-829392633/s3jHCNzzt3oQ-Y2-iwM" });
		window.gtag("event", "conversion", {
			"allow_custom_scripts": true,
			"send_to": "DC-8236637/step30/dcmok0+standard",
		});
	}, [shouldShow]);

	return shouldShow && (
		<img
			height="1"
			width="1"
			style={{ borderStyle: "none", position: "absolute" }}
			alt=""
			src="//insight.adsrvr.org/track/conv/?adv=74j66hn&ct=0:243h249&fmt=3"
		/>
	);
};

export default ActionPartialSignup;



// WEBPACK FOOTER //
// ./src/routers/shared/components/ActionPartialSignup.jsx